import React, { Fragment } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination, Checkbox} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import OTReadOnlyRow from './OTReadOnlyRow';
import OTEditableRow from './OTEditableRow';
import { useEffect } from 'react';
import { useAddNewofficetypeMutation, useDeleteofficetypeMutation, useGetofficetypeQuery, useUpdateofficetypeMutation } from '../../../features/officetype/officetypeApiSlice';
import { useGetdesignationsQuery } from '../../../features/designations/designationApiSlice';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExcelDownload from '../../../data/exceldownload';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Addcategform = styled.form`
  display: flex;
  margin:10px;
  align-items: center;
  justify-content:space-between;
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`

const ChipDiv = styled.div`
  background-color: #d4d5d6;
  display: inline-block;
  font-size: 14px;
  border-radius: 30px;
  height: 30px;
  padding: 0 4px 0 1rem;
  display: inline-flex;
  align-items: center;
  margin: 0 0.3rem 0.3rem 0;
`

const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;
  justify-content:space-between;
  align-items:center;
`

const tableFontSize = 18;


function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
//This is a function which returns true if
// 1. If B is an Array there should be atleast one common element between A & B.
// 2. If B is String the Array A should have one of the element as that string.

const hasCommonElement = (A, B)=> {
  if (Array.isArray(B)) {
    // Check if there is at least one common element between arrays A and B
    return A.some(element => B.includes(element));
  } else if (typeof B === 'string') {
    // Check if array A contains the string B
    return A.includes(B);
  } else {
    // Handle other cases (e.g., B is neither an array nor a string)
    return false;
  }
}

export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [searchData, setSearchData] = useState({
    type:"",
    level:[],
    unitHead:[]
  });

  const {officetype} = useGetofficetypeQuery("officeTypeList", {
    selectFromResult: ({ data }) => ({
      officetype: data?.entities
    }),
  })

  const {designations} = useGetdesignationsQuery("designations", {
    selectFromResult: ({ data }) => ({
      designations: data?.entities
    }),
  })  
 
  const [addNewOffType] = useAddNewofficetypeMutation();
  const [updateOfficetype] = useUpdateofficetypeMutation();
  const [deleteOfficetype] = useDeleteofficetypeMutation();

  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({});
  const [addOfftypeData, setAddOfftypeData] = useState({});
  const [downloadData, setDownloadData] = useState({});

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) =>{
    event.preventDefault();
    try{
      let bodyobject ={"type":addOfftypeData.officetype, "level":addOfftypeData.level, "unitHead": addOfftypeData.unitheaddesignations};
      const found = Object.values(officetype).some(el => el.type === addOfftypeData.officetype);
      if(found){
        alert(`Office Type already exist`);
        let tempOffType = {...addOfftypeData}
        tempOffType.officetype = "";
        tempOffType.level = "";
        tempOffType.unitheaddesignations = "";
        setAddOfftypeData(tempOffType);
        return
      }
      if(!addOfftypeData?.officetype?.length){
        alert(`Please Enter value for Office Type`)
        return;
      }
      if(!addOfftypeData?.level?.length){
        alert("Please select value for Level");
        return
      }
      if(!addOfftypeData?.unitheaddesignations?.length){
        alert("Please select atleast one value for Unit Head Designation");
        return
      }
      const res = await addNewOffType(bodyobject) ;
      alert(`New Office Type ${bodyobject.type} at ${bodyobject.level} created`);
      let tempOffType = {...addOfftypeData}
      tempOffType.officetype = "";
      tempOffType.level = "";
      tempOffType.unitheaddesignations = "";
      setAddOfftypeData(tempOffType);
    } catch(err){console.log(err)}
  }

 

  const onClickEdit = (e,k,row)=>{
    setEditCategory(k+1);
  }

  const onChangeAddOffType = (event, newValue, name) =>{
    let temp ={...addOfftypeData}
    if(event.target.name?.length){
      temp = {...temp, [event.target.name]:event.target.value}
    }
    if(name?.length){
      temp = {...temp, [name]:newValue}
    }
    setAddOfftypeData(temp);
  }

  const onChangeEditOffType = (event, newValue, name) =>{
    let temp ={...editFormData};
    if(event.target.name?.length){
      temp = {...temp, [event.target.name]:event.target.value}
    }
    if(name?.length){
      temp = {...temp, [name]:newValue}
    }
    setEditFormData(temp);
  }

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    try{
    setEditCategory(null);
    const id = tabledata[((page)*(rowsPerPage))+(editCategory-1)].id;

    if ((editFormData[`unitheaddesignations${((page)*(rowsPerPage))+(editCategory-1)}`].length) ){ 
       let body ={"id":id, "type":editFormData[`officetype${((page)*(rowsPerPage))+(editCategory-1)}`], "level":editFormData[`level${((page)*(rowsPerPage))+(editCategory-1)}`], "unitHead": editFormData[`unitheaddesignations${((page)*(rowsPerPage))+(editCategory-1)}`]};
      const response = await updateOfficetype(body)
    }    
    }catch(err){}
  }
  

  const handleCancelClick = (e,k) => { 
    setEditCategory(null);
  };

  const handleDeleteClick = async (e,k,id) => {
    e.preventDefault();
    let body = {"id":id}
    const result = await deleteOfficetype(body);
  };

  const handleSearchChange = (event, newValue, name) =>{
    let tempData = structuredClone(Object.values(officetype));
    let tempSearchData = structuredClone(searchData);
    console.log(event?.target?.name)
    console.log(event?.target?.value)

    if(event?.target?.name){
      tempSearchData[event.target.name] = event.target.value;
      setSearchData(tempSearchData);
     }else{
      tempSearchData[name] = newValue
      setSearchData(tempSearchData);
     }
     for(let key in tempSearchData){
      console.log(tempData[0][key])
      console.log(tempSearchData[key])
      if(typeof tempSearchData[key] === "string" && tempSearchData[key].length){
          tempData = tempData.filter(x=> x[key].toLowerCase().includes(tempSearchData[key].toLowerCase()))
          console.log(tempData)
      }
      if(typeof tempSearchData[key] === "object" && tempSearchData[key].length ){
        console.log("Entered2")
        if(typeof tempSearchData[key][0] === "string" ){
          tempData = tempData.filter(x=> hasCommonElement(tempSearchData[key], x[key]))
        }
        if(typeof tempSearchData[key][0] === "number"){
          tempData = tempData.filter(x => tempSearchData[key]?.includes(x[key]))
        }
      }
    }
    setTabledata(tempData.sort((a, b) => {
      // Extract numeric part from strings
      let numA = parseInt(a.level.match(/\d+/)[0]);
      let numB = parseInt(b.level.match(/\d+/)[0]);                  
      return numA - numB;
    }));
  }


  useEffect(()=>{
    if(officetype){
      const officeTypeArray = Object.values(officetype);
      setTabledata(officeTypeArray.sort((a, b) => {
        // Extract numeric part from strings
        let numA = parseInt(a.level.match(/\d+/)[0]);
        let numB = parseInt(b.level.match(/\d+/)[0]);                  
        return numA - numB;
      }));
      let temp = {...editFormData};
      for(let i=0;i< officeTypeArray.length;i++){
        temp = {...temp, [`unitheaddesignations${i}`]:officeTypeArray[i].unitHead, [`level${i}`]:officeTypeArray[i].level, [`officetype${i}`]:officeTypeArray[i].type}
      }
      setEditFormData(temp);
    }
  },[officetype])

  //Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["type", "level","unitHead"]
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, ...others} = val;
      others = {...others, ["type"]:val.type, ["level"]:val.level,["unitHead"]:val.unitHead.join(", ") }
      finalDownloadData.push(others)
    }

    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [tabledata])

   
  return (
    <>    
      <HeadingWrap>
        <Span>Add New Office Type</Span>
      </HeadingWrap>
      <ComplaintCategoryWrapper>
      <Addcategform onSubmit={onSubmit}>
        <TextField
          id="outlined-basic"
          size='small'
          name='officetype'
          onChange={(event, newValue) => onChangeAddOffType(event, newValue)}
          label="Enter New Office Type"
          value={addOfftypeData.officetype || ""}
          variant="outlined"
          sx={{backgroundColor:"white", width:"200px", height:"40px"}}
        />
        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disablePortal
          id="combo-box-demo"
          size='small'
          value={addOfftypeData?.level || "" }
          onChange={(event, newValue) => onChangeAddOffType(event, newValue, "level")}
          options={Array(10).fill("level").map((item, index) => `${item}${index+1}`)}
          sx={{backgroundColor:"white", width:"200px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
          renderInput={(params) => <TextField {...params} label={"Select Level"} />}
        />
        <Autocomplete
          multiple
          id="combo-box-demo"
          size='small'
          options={designations? (Object.values(designations)?.map(x => x.name )) : []}
          sx={{backgroundColor:"white", width:"250px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
          // getOptionLabel={(option) => option.title}
          value={addOfftypeData?.unitheaddesignations? addOfftypeData?.unitheaddesignations:[]}
          onChange={(event, newValue) =>onChangeAddOffType(event, newValue, "unitheaddesignations")}
          renderInput={(params) => ( 
            <TextField
              {...params}
              variant="outlined"
              label="Unit Head Designations"
              placeholder="Favorites"
            />
          )}
        />   
        <SubmitButton type='submit'>Submit</SubmitButton>
      </Addcategform>

      <Button2Div>
          <ExcelDownload data={downloadData} filename={"officeTypes"} sheetName={"sheet1"}/>
      </Button2Div> 


    </ComplaintCategoryWrapper>
    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
        <TableRow>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Office Type</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}}  align="left">Level</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"35%"}}}align="left">UnitHead Designations</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}}align="left">Edit</TableCell>
        </TableRow>

        <TableRow>
          <TableCell ></TableCell>
          <TableCell >
            <TextField sx={{background:"white"}}  name='type' onChange={handleSearchChange} label="Search Office Type" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >  
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "level")}
                size="small"
                value={searchData.level}
                options={officetype? Object.values( officetype)?.map(x=> x.level).filter((item,index)=> Object.values(      officetype)?.map(x=> x.level).indexOf(item) === index).sort((a, b) => {
                  // Extract numeric part from strings
                  let numA = parseInt(a.match(/\d+/)[0]);
                  let numB = parseInt(b.match(/\d+/)[0]);                  
                  return numA - numB;
                }):[]}      
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search Level"  sx={{background:"white", width:"70%"}} />
                )}
                />
          </TableCell>
          <TableCell >
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "unitHead")}
                size="small"
                value={searchData.unitHead}
                options={officetype? Object.values(officetype)?.map(x=> x.unitHead).flat().filter((item,index)=> Object.values(officetype)?.map(x=> x.unitHead).flat().indexOf(item) === index).sort(): []}
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search UnitHead Designations"  sx={{background:"white", width:"70%"}} />
                )}
                />
          </TableCell>
          <TableCell ></TableCell>
        </TableRow>


      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
                <OTEditableRow row={row} k={key} editFormData={editFormData}
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage} editCategory={editCategory} onChangeEditOffType={onChangeEditOffType} officetype={officetype} designations={designations} tableFontSize={tableFontSize} SubmitButton={SubmitButton}
               />

                :<OTReadOnlyRow row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} SubmitButton={SubmitButton}  ChipDiv={ChipDiv}
                  page={page} rowsPerPage={rowsPerPage} editCategory={editCategory}
                  tableFontSize={tableFontSize}           
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>
    </>
  );
}